import React from "react";
import { getOperatorsByType, getOperatorLabel, NO_VALUE_OPERATORS } from "./constants";

export default function FilterRule({ 
  rule, 
  index,
  availableFields, 
  t, 
  onChange, 
  onRemove,
  isOnly 
}) {
  const selectedField = availableFields.find(f => f.key === rule.field);
  const fieldType = selectedField?.type || "text";
  const operators = getOperatorsByType(fieldType);
  const isBetween = rule.operator === "between";
  const needsValue = rule.operator && !NO_VALUE_OPERATORS.includes(rule.operator);

  const handleFieldChange = (val) => {
    onChange(index, { 
      field: val, 
      operator: "", 
      value: "", 
      valueMin: "", 
      valueMax: "" 
    });
  };

  const handleOpChange = (val) => {
    onChange(index, { 
      operator: val, 
      value: "", 
      valueMin: "", 
      valueMax: "" 
    });
  };

  const handleValue = (key, val) => {
    onChange(index, { [key]: val });
  };

  return (
    <div className="filter-rule-row">
      {/* Верхняя строка: поле + оператор + кнопка удаления */}
      <div className="filter-rule-top-row">
        <select 
          className="form-input filter-rule-field"
          value={rule.field} 
          onChange={e => handleFieldChange(e.target.value)}
        >
          <option value="">{t.selectField}</option>
          {availableFields.map(f => (
            <option key={f.key} value={f.key}>{f.key} ({f.label})</option>
          ))}
        </select>

        <select
          className="form-input filter-rule-operator"
          value={rule.operator}
          disabled={!rule.field}
          onChange={e => handleOpChange(e.target.value)}
        >
          <option value="">{t.selectOperator}</option>
          {operators.map(op => (
            <option key={op} value={op}>
              {getOperatorLabel(fieldType, op)}
            </option>
          ))}
        </select>

        {!isOnly && (
          <button 
            className="btn-remove-rule"
            onClick={() => onRemove(index)}
            title={t.removeRule || "Remove rule"}
          >
            ×
          </button>
        )}
      </div>

      {/* Нижняя строка: значение на всю ширину */}
      {rule.operator && (
        <div className="filter-rule-bottom-row">
          {isBetween ? (
            <div className="filter-rule-between">
              {fieldType === "date" ? (
                <>
                  <input 
                    className="form-input"
                    type="date" 
                    lang="en"
                    value={rule.valueMin || ""}
                    onChange={e => handleValue("valueMin", e.target.value)} 
                  />
                  <span className="filter-rule-between-sep">—</span>
                  <input 
                    className="form-input"
                    type="date" 
                    lang="en"
                    value={rule.valueMax || ""}
                    onChange={e => handleValue("valueMax", e.target.value)} 
                  />
                </>
              ) : (
                <>
                  <input 
                    className="form-input"
                    type="number" 
                    placeholder={t.minValue || "Min"} 
                    value={rule.valueMin || ""}
                    onChange={e => handleValue("valueMin", e.target.value)} 
                  />
                  <span className="filter-rule-between-sep">—</span>
                  <input 
                    className="form-input"
                    type="number" 
                    placeholder={t.maxValue || "Max"} 
                    value={rule.valueMax || ""}
                    onChange={e => handleValue("valueMax", e.target.value)} 
                  />
                </>
              )}
            </div>
          ) : needsValue ? (
            fieldType === "date" ? (
              <input 
                lang="en"
                className="form-input"
                type="date"
                value={rule.value || ""}
                onChange={e => handleValue("value", e.target.value)}
              />
            ) : fieldType === "text" || fieldType === "string" ? (
              <textarea
                className="form-input filter-rule-textarea"
                placeholder={t.enterValue || "Enter value"}
                value={rule.value || ""}
                onChange={e => handleValue("value", e.target.value)}
                rows={3}
              />
            ) : (
              <input 
                className="form-input"
                type="number"
                placeholder={t.enterValue || "Enter value"}
                value={rule.value || ""}
                onChange={e => handleValue("value", e.target.value)}
              />
            )
          ) : (
            <div className="filter-rule-no-value">
              {t.noValueNeeded || "No value needed"}
            </div>
          )}
        </div>
      )}
    </div>
  );
}